export const forumSections = ["求助帮忙", "闲置转让", "兴趣小组"];

export const forumList = [
  {
    id: "f1",
    title: "求助：家里老人腿脚不便，想问附近哪里有上门理发",
    excerpt: "爷爷八十多岁了，下楼不方便，想问问咱们社区有没有能上门理发的师傅或者邻居，谢谢大家！",
    author: "小周家的猫",
    avatar: "https://readdy.ai/api/search-image?query=Cute%20friendly%20orange%20cat%20avatar%20illustration%2C%20flat%20minimal%20style%2C%20warm%20colors%2C%20soft%20background&width=200&height=200&seq=avatar-f1&orientation=squarish",
    section: "求助帮忙",
    tags: ["助老", "上门服务"],
    date: "2026-10-09",
    replies: 23,
    views: 860,
    content: [
      "各位邻居好，我爷爷今年八十三岁，行动不太方便，带他出门理发挺折腾的。想问问咱们社区有没有能上门理发的师傅，或者有热心邻居愿意帮忙的？",
      "价格好商量，主要图个方便。如果有知道的朋友，麻烦留言或者私信我，非常感谢！",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=Friendly%20community%20barber%20giving%20elderly%20man%20a%20haircut%20at%20home%20with%20warm%20lighting%2C%20caring%20atmosphere%2C%20soft%20tones&width=900&height=600&seq=forum-f1-img&orientation=landscape",
    ],
    repliesList: [
      { author: "楼下李阿姨", date: "2026-10-09 10:12", content: "三号楼的王师傅以前是理发师，退休在家，可以问问他，人特别热心。" },
      { author: "清风徐来", date: "2026-10-09 11:40", content: "社区服务中心好像有便民上门的登记，你可以去问问，好像还挺便宜的。" },
      { author: "小周家的猫", date: "2026-10-09 13:05", content: "谢谢两位！我下午就去社区中心问问，太感谢了。" },
      { author: "热心邻居老张", date: "2026-10-09 15:22", content: "需要搭把手抬老人的话喊我一声，我住六号楼，随时有空。" },
    ],
  },
  {
    id: "f2",
    title: "闲置转让：九成新儿童自行车一辆，适合4-6岁",
    excerpt: "孩子长个了骑不下了，九成新，带辅助轮，便宜出给邻居，自提优先。",
    author: "两娃的爸",
    avatar: "https://readdy.ai/api/search-image?query=Friendly%20dad%20avatar%20illustration%2C%20flat%20minimal%20style%2C%20warm%20orange%20tones%2C%20soft%20plain%20background&width=200&height=200&seq=avatar-f2&orientation=squarish",
    section: "闲置转让",
    tags: ["闲置", "儿童用品"],
    date: "2026-10-08",
    replies: 15,
    views: 640,
    content: [
      "孩子长得太快，这辆儿童自行车买了不到一年就骑不下了，九成新，带辅助轮，刹车都正常。",
      "原价三百多，现在一百块出，自提优先，小区内可以帮忙送。有需要的邻居留言就行。",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=Bright%20kids%20bicycle%20with%20training%20wheels%20in%20good%20condition%2C%20clean%20simple%20background%2C%20soft%20daylight%2C%20product%20photo%20style&width=900&height=600&seq=forum-f2-img&orientation=landscape",
    ],
    repliesList: [
      { author: "宝妈小雅", date: "2026-10-08 09:30", content: "请问还在吗？我家娃正好四岁，想要！" },
      { author: "两娃的爸", date: "2026-10-08 09:35", content: "在的，你住几号楼？我给你送过去看看。" },
      { author: "宝妈小雅", date: "2026-10-08 09:40", content: "二号楼，太感谢了！" },
    ],
  },
  {
    id: "f3",
    title: "兴趣小组：周末一起晨跑打卡，有想加入的吗",
    excerpt: "想组织一个社区晨跑小队，周末早上六点半广场集合，慢跑五公里，欢迎各年龄段。",
    author: "跑步的老陈",
    avatar: "https://readdy.ai/api/search-image?query=Cheerful%20runner%20avatar%20illustration%2C%20flat%20minimal%20style%2C%20green%20accent%20colors%2C%20soft%20plain%20background&width=200&height=200&seq=avatar-f3&orientation=squarish",
    section: "兴趣小组",
    tags: ["运动", "晨跑", "交友"],
    date: "2026-10-07",
    replies: 41,
    views: 1320,
    content: [
      "年纪大了越发觉得运动重要，一个人跑又容易偷懒。想组个社区晨跑小队，每周六早上六点半在槐树广场集合，慢跑五公里，配速随意，跑完一起喝豆浆。",
      "不限年龄、不限快慢，主要是互相监督、交个朋友。有兴趣的邻居留个言，我拉个群。",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=Group%20of%20neighbors%20jogging%20together%20in%20a%20green%20park%20at%20sunrise%2C%20morning%20light%2C%20healthy%20energetic%20atmosphere%2C%20warm%20tones&width=900&height=600&seq=forum-f3-img&orientation=landscape",
    ],
    repliesList: [
      { author: "爱运动的刘姐", date: "2026-10-07 08:15", content: "算我一个！我住五号楼，六点半没问题。" },
      { author: "夜猫子小王", date: "2026-10-07 09:50", content: "六点半有点早哈，能不能七点？" },
      { author: "跑步的老陈", date: "2026-10-07 10:02", content: "先按六点半来，后面可以商量，人多好办事。" },
      { author: "清风徐来", date: "2026-10-07 12:30", content: "加我一个，正好想找个伴一起跑。" },
      { author: "楼下李阿姨", date: "2026-10-07 18:44", content: "老陈带带我，我跑得慢。", },
    ],
  },
  {
    id: "f4",
    title: "求助：楼上晾衣滴水到我家阳台，怎么沟通比较好",
    excerpt: "楼上邻居晾衣服总滴水，淋湿了我晾的被子，想委婉沟通又怕伤和气，想听听大家建议。",
    author: "住三楼的邻居",
    avatar: "https://readdy.ai/api/search-image?query=Thoughtful%20neighbor%20avatar%20illustration%2C%20flat%20minimal%20style%2C%20soft%20yellow%20tones%2C%20plain%20background&width=200&height=200&seq=avatar-f4&orientation=squarish",
    section: "求助帮忙",
    tags: ["邻里沟通", "和谐"],
    date: "2026-10-05",
    replies: 28,
    views: 910,
    content: [
      "楼上邻居晾衣服经常滴水，好几次把我家阳台晾的被子都淋湿了。想上去说一声，又怕说得不好伤和气，大家有什么委婉又管用的办法吗？",
      "其实也不是什么大事，就是希望能互相体谅一下。",
    ],
    images: [],
    repliesList: [
      { author: "会做人的老李", date: "2026-10-05 09:10", content: "提点水果上去坐坐，顺口提一句，一般都能理解，别一上来就指责。" },
      { author: "清风徐来", date: "2026-10-05 10:20", content: "可以先在楼栋群礼貌说一下，不点名，给个台阶，效果往往更好。" },
      { author: "住三楼的邻居", date: "2026-10-05 11:05", content: "谢谢，我打算带点自家做的点心上去聊聊。" },
    ],
  },
  {
    id: "f5",
    title: "闲置转让：全新未拆封电饭煲，搬家闲置",
    excerpt: "搬家时发现多买了一个电饭煲，全新未拆封，型号3L，低价转给需要的邻居。",
    author: "搬家的阿Mei",
    avatar: "https://readdy.ai/api/search-image?query=Friendly%20woman%20avatar%20illustration%2C%20flat%20minimal%20style%2C%20warm%20peach%20tones%2C%20plain%20background&width=200&height=200&seq=avatar-f5&orientation=squarish",
    section: "闲置转让",
    tags: ["闲置", "家电"],
    date: "2026-10-03",
    replies: 9,
    views: 480,
    content: [
      "搬家整理东西，发现多买了一个电饭煲，全新未拆封，3升容量，适合两三口之家。",
      "原价两百多，现一百二出，小区自提。有需要的邻居留言。",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=Brand%20new%20sealed%20rice%20cooker%20in%20box%20on%20a%20clean%20table%2C%20soft%20studio%20lighting%2C%20simple%20neutral%20background%2C%20product%20photo&width=900&height=600&seq=forum-f5-img&orientation=landscape",
    ],
    repliesList: [
      { author: "新搬来的小两口", date: "2026-10-03 14:20", content: "正好需要！请问还出吗？" },
      { author: "搬家的阿Mei", date: "2026-10-03 14:35", content: "在的，你留个联系方式，我给你送过去。" },
    ],
  },
  {
    id: "f6",
    title: "兴趣小组：社区合唱团招新，欢迎爱唱歌的你",
    excerpt: "社区合唱团每周三晚上排练，现有成员二十余人，欢迎喜欢唱歌的邻居加入。",
    author: "合唱团老团长",
    avatar: "https://readdy.ai/api/search-image?query=Kind%20elderly%20choir%20leader%20avatar%20illustration%2C%20flat%20minimal%20style%2C%20green%20tones%2C%20plain%20background&width=200&height=200&seq=avatar-f6&orientation=squarish",
    section: "兴趣小组",
    tags: ["音乐", "合唱", "交友"],
    date: "2026-10-01",
    replies: 34,
    views: 1050,
    content: [
      "社区合唱团成立三年了，现有成员二十多人，每周三晚上七点半在活动室排练。不看基础、不挑嗓子，只要你爱唱歌就欢迎。",
      "今年还准备参加街道的文艺汇演，有兴趣的邻居快来报名吧！",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=Community%20choir%20group%20singing%20together%20in%20a%20bright%20hall%2C%20warm%20friendly%20atmosphere%2C%20soft%20lighting%2C%20harmonious%20tones&width=900&height=600&seq=forum-f6-img&orientation=landscape",
    ],
    repliesList: [
      { author: "爱唱歌的赵姐", date: "2026-10-01 20:10", content: "我要报名！一直想找个合唱团。" },
      { author: "退休的老吴", date: "2026-10-01 21:00", content: "请问需要会看五线谱吗？" },
      { author: "合唱团老团长", date: "2026-10-01 21:15", content: "不需要的，我们跟着唱就行，慢慢就熟了。" },
    ],
  },
];